import axios, { AxiosStatic } from 'axios';

export default class BaseSearchService {
    protected axios: AxiosStatic = axios; 

    get isDev() {
        return Boolean(process.env.VUE_APP_BASE_API_URL);
    }

    constructor() {
        axios.defaults.baseURL = process.env.VUE_APP_BASE_API_URL || null;
    }
}